<template>
  <div class="row">
    <div class="col-md">
      <dl class="dl-horizontal">

        <dt>id</dt>
        <dd><router-link
          class="text-monospace text-muted"
          :to="`/commands/${command.id}`"
        >{{command.id}}</router-link></dd>

        <dt>modem_uid</dt>
        <dd><router-link
          class="text-monospace text-muted"
          :to="`/modems/${command.modem_uid}`"
        >{{command.modem_uid}}</router-link></dd>

        <template v-if="command.machine_id">
          <dt>machine_id</dt>
          <dd><router-link
            class="text-monospace text-muted"
            :to="`/machines/${command.machine_id}`"
          >{{command.machine_id}}</router-link></dd>
        </template>

        <template v-if="command.receipts && command.receipts.length">
          <dt>receipts</dt>
          <dd v-for="receipt in command.receipts"><router-link
            class="text-monospace text-muted"
            :to="`/receipts/${receipt.id}`"
          >{{receipt.id}}</router-link></dd>
        </template>
        <template v-if="isMedia">
          <dt>content</dt>
          <dd><a
            class="text-monospace text-muted"
            :href="'/api/admin/commands/' + command.id + '/download'"
          >Скачать</a></dd>
        </template>


        <template v-for="(value, key) in showData" v-if="value">
          <dt>{{key}}</dt>
          <dd class="text-monospace text-muted">{{value}}</dd>
        </template>

        <btn-action class="btn btn-outline-danger" @click="deleteCommand">Удалить команду</btn-action>
      </dl>
    </div>
    <div class="col-md-8">
      <template v-if="command.data !== undefined">
        <strong>Исходящие данные</strong>
        <pre
          v-if="command.data"
          class="modem-command-data-result mx-0 mt-0 mb-3 p-3"
        >{{ command.data.trim() }}</pre>
        <div class="text-muted">
          <div v-if="command.data === ''">файл с исходящими данными пустой</div>
          <div v-if="command.data === null">файл с исходящими данными отсутствует</div>
        </div>
      </template>
      <template v-if="'data_result' in command">
        <strong>Входящие данные</strong>
        <pre
          v-if="command.data_result"
          class="modem-command-data-result m-0 p-3"
        >{{ command.data_result.trim() }}</pre>
        <div class="text-muted">
          <div v-if="command.data_result === ''">файл с входящими данными пустой</div>
          <div v-if="command.data_result === null">файл с входящими данными отсутствует</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import pick from 'lodash/pick'
  import api from '@/api'

  export default {
    props: {
      command: {
        type: Object,
      },
    },
    computed: {
      showData () {
        return pick(this.command, [
          // 'id',
          'timestamp',
          'type',
          'status',
          'error_code',
          // 'data_result',
          'requested_at',
          'placed_at',
          'modem_deleted_exec_at',
          'received_at',
          'state',
        ])
      },
      isMedia () {
        return ['jpeg', 'wav'].includes(this.command.type)
      },
    },
    methods: {
      deleteCommand () {
        if (window.confirm('Удалить команду?')) {
          return api.delete(`commands/${this.command.id}`)
            .then(() => window.location.reload())
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .modem-command-data-result {
    background-color: $gray-200;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modem-command-details.vue